export const GET_COMPUTATION_METHOD_API = `${process.env.REACT_APP_API_BASE_URL}/computation_method/`;
export const GET_TAX_SETTINGS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_settings/`;
export const POST_TAX_SETTINGS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_settings/`;

export const GET_CIT_REBATE_API = `${process.env.REACT_APP_API_BASE_URL}/cit_rebate/`;
export const POST_CIT_REBATE_API = `${process.env.REACT_APP_API_BASE_URL}/cit_rebate/`;

export const REQUEST_FOR_PASSWORD_RESET_API = `${process.env.REACT_APP_API_BASE_URL}/users/password_reset/`;

export const GET_SERVICE_PROVIDER_COMPANIES_API = `${process.env.REACT_APP_API_BASE_URL}/service_provider_companies/`;
export const POST_SERVICE_PROVIDER_COMPANIES_API = `${process.env.REACT_APP_API_BASE_URL}/service_provider_companies/`;

export const GET_CUSTOMERS_API = `${process.env.REACT_APP_API_BASE_URL}/customers/`;
export const POST_CUSTOMERS_API = `${process.env.REACT_APP_API_BASE_URL}/customers/`;
export const GET_CUSTOMER_BY_COMPANY_NAME_API = `${process.env.REACT_APP_API_BASE_URL}/customer/customer_by_company_name`;

export const DOCUMENTATION_API = `${process.env.REACT_APP_API_BASE_URL}/documentation/`;

export const GET_TAX_COMPUTATION_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_details/`;
export const POST_TAX_COMPUTATION_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_details/`;
export const GET_MANAGE_FIRST_YA_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_details/customers-without-tax-computation/`;

export const GET_TAX_COMPUTATION_REPORTS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_details/tax-computation-reports/`;

export const GET_ESTIMATED_CHARGEABLE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/estimated_chargeable_income/`;
export const POST_ESTIMATED_CHARGEABLE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/estimated_chargeable_income/`;

export const GET_ECI_NOTIFICATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/eci-notifications/`;
export const POST_ECI_NOTIFICATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/eci-notifications/`;
export const GET_ECI_NOTIFICATIONS_BY_FYE_API = `${process.env.REACT_APP_API_BASE_URL}/eci-notifications/by-fye/`;
export const SEND_ECI_EMAIL_API = `${process.env.REACT_APP_API_BASE_URL}/eci-notifications/`;
export const BULK_SEND_ECI_EMAIL_API = `${process.env.REACT_APP_API_BASE_URL}/eci-notifications/bulk-send/`;
export const GET_ECI_EMAIL_LOGS_API = `${process.env.REACT_APP_API_BASE_URL}/eci-email-logs/`;

export const SEND_AUTHENTICATION_REQUEST_API = `${process.env.REACT_APP_API_BASE_URL}/iras_tax/send_authentication_request_to_iras/`;
//export const GET_CALLBACK_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_details/`;

export const GET_ECI_AUTHORISED_PERSONS_API = `${process.env.REACT_APP_API_BASE_URL}/eci_authorized_persons/`;
export const POST_ECI_AUTHORISED_PERSONS_API = `${process.env.REACT_APP_API_BASE_URL}/eci_authorized_persons/`;

export const GET_EXPENSE_ACCOUNT_FULL_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_full/`;
export const POST_EXPENSE_ACCOUNT_FULL_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_full/`;

export const GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_fully_deductible/`;
export const POST_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_fully_deductible/`;
export const GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_AVAILABLE_ITEMS_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_fully_deductible/available-pnl-items/`;

export const GET_INVESTMENT_PROPERTY_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/investment_property_summary/`;
export const POST_INVESTMENT_PROPERTY_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/investment_property_summary/`;

export const GET_EXPENSE_ACCOUNT_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_adjustment/`;
export const POST_EXPENSE_ACCOUNT_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account_adjustment/`;

export const GET_USERS_API = `${process.env.REACT_APP_API_BASE_URL}/user/`;
export const POST_USERS_API = `${process.env.REACT_APP_API_BASE_URL}/user/`;

export const GET_PROFILE_API = `${process.env.REACT_APP_API_BASE_URL}/user`;
export const POST_PROFILE_API = `${process.env.REACT_APP_API_BASE_URL}/user/`;

export const GET_USER_ACCESS_LEVELS_API = `${process.env.REACT_APP_API_BASE_URL}/group/`;
export const POST_USER_ACCESS_LEVELS_API = `${process.env.REACT_APP_API_BASE_URL}/group/`;
export const POST_USER_ACCESS_LEVEL_PERMISSIONS_API = `${process.env.REACT_APP_API_BASE_URL}/group/set_permission/`;
export const POST_USER_DASHBOARD_LEVEL_PERMISSIONS_API = `${process.env.REACT_APP_API_BASE_URL}/group/set_dashboard_permission/`;

export const CHANGE_PASSWORD_API = `${process.env.REACT_APP_API_BASE_URL}/users/change_password/`;
export const LOGIN_API = `${process.env.REACT_APP_API_BASE_URL}/users/login/`;
export const VERIFY_OTP_API = `${process.env.REACT_APP_API_BASE_URL}/users/verify-otp/`;
export const RESEND_OTP_API = `${process.env.REACT_APP_API_BASE_URL}/users/resend-otp/`;
export const LOGOUT_API = `${process.env.REACT_APP_API_BASE_URL}/user-activity/logout_register/`;

export const GET_TRADING_METHOD_SCHEDULE_CONTENT_API = `${process.env.REACT_APP_API_BASE_URL}/trading_content/`;
export const UPDATE_SCHEDULE_ROLLOVER_API = `${process.env.REACT_APP_API_BASE_URL}/content_schedule/update-rollover/`;

export const GET_TRADING_METHOD_SCHEDULE_CONTENT_API_NEW = `${process.env.REACT_APP_API_BASE_URL}/content_schedule/`;

export const GET_TRADING_METHOD_SCHEDULE1_API = `${process.env.REACT_APP_API_BASE_URL}/trading_schedule01/`;
export const POST_TRADING_METHOD_SCHEDULE1_API = `${process.env.REACT_APP_API_BASE_URL}/trading_schedule01/`;

export const GET_PROFIT_AND_LOSS_STATEMENT_API = `${process.env.REACT_APP_API_BASE_URL}/trading_profit_and_loss_statement/`;
export const POST_PROFIT_AND_LOSS_STATEMENT_API = `${process.env.REACT_APP_API_BASE_URL}/trading_profit_and_loss_statement/`;

export const GET_DEPRECIATION_SCHEDULE_API = `${process.env.REACT_APP_API_BASE_URL}/trading_depreciation_schedule/`;
export const POST_DEPRECIATION_SCHEDULE_API = `${process.env.REACT_APP_API_BASE_URL}/trading_depreciation_schedule/`;

export const GET_RENTAL_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/rental_income/`;
export const POST_RENTAL_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/rental_income/`;
export const COPY_RENTAL_INCOME_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/rental_income/copy_from_previous_year/`;

export const GET_INVESTMENT_HOLDING_PROFIT_AND_LOSS_STATEMENT_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_profit_and_loss_statement/`;
export const POST_INVESTMENT_HOLDING_PROFIT_AND_LOSS_STATEMENT_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_profit_and_loss_statement/`;

export const GET_INVESTMENT_HOLDING_OTHER_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_other_income/`;
export const POST_INVESTMENT_HOLDING_OTHER_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_other_income/`;
export const COPY_INVESTMENT_HOLDING_OTHER_INCOME_FROM_PREVIOUS_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_other_income/copy_from_previous_year/`;

export const GET_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_other_non_taxable_income/`;
export const POST_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_other_non_taxable_income/`;

export const GET_INVESTMENT_HOLDING_RENTAL_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_rental_income/`;
export const POST_INVESTMENT_HOLDING_RENTAL_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_rental_income/`;

export const GET_INVESTMENT_HOLDING_DIVIDEND_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_dividend_income/`;
export const POST_INVESTMENT_HOLDING_DIVIDEND_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_dividend_income/`;
export const COPY_INVESTMENT_HOLDING_DIVIDEND_INCOME_FROM_PREVIOUS_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_dividend_income/copy_from_previous_year/`;

export const GET_INVESTMENT_HOLDING_INTEREST_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_income/`;
export const POST_INVESTMENT_HOLDING_INTEREST_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_income/`;
export const COPY_INVESTMENT_HOLDING_INTEREST_INCOME_FROM_PREVIOUS_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_income/copy_from_previous_year/`;

export const GET_EXPENSE_ACCOUNT_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account/`;
export const POST_EXPENSE_ACCOUNT_API = `${process.env.REACT_APP_API_BASE_URL}/expense_account/`;

export const GET_EMAIL_TEMPLATES_LIST_API = `${process.env.REACT_APP_API_BASE_URL}/email_templates/`;
export const GET_EMAIL_CATEGORIES_API = `${process.env.REACT_APP_API_BASE_URL}/email_categories/`;

export const GET_DIVIDEND_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/dividend_income/`;
export const POST_DIVIDEND_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/dividend_income/`;
export const COPY_DIVIDEND_INCOME_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/dividend_income/copy_from_previous_year/`;

export const GET_FOREIGN_TRADE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/foreign_trade_income/`;
export const POST_FOREIGN_TRADE_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/foreign_trade_income/`;
export const COPY_FOREIGN_TRADE_INCOME_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/foreign_trade_income/copy_from_previous_year/`;

export const GET_MEDICAL_EXPENSES_API = `${process.env.REACT_APP_API_BASE_URL}/medical_expenses/`;
export const POST_MEDICAL_EXPENSES_API = `${process.env.REACT_APP_API_BASE_URL}/medical_expenses/`;
export const COPY_MEDICAL_EXPENSES_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/medical_expenses/copy_from_previous_year/`;

export const GET_PROVISIONAL_ALLOWANCES_API = `${process.env.REACT_APP_API_BASE_URL}/provisional_allowances/`;
export const POST_PROVISIONAL_ALLOWANCES_API = `${process.env.REACT_APP_API_BASE_URL}/provisional_allowances/`;

export const GET_INTEREST_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/interest_adjustment/`;
export const POST_INTEREST_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/interest_adjustment/`;
export const COPY_INTEREST_ADJUSTMENT_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/interest_adjustment/copy_from_previous_year/`;

export const GET_UNREMITTED_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/unremitted_income/`;
export const POST_UNREMITTED_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/unremitted_income/`;

export const GET_INVESTMENT_HOLDING_UNREMITTED_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_unremitted_income/`;
export const POST_INVESTMENT_HOLDING_UNREMITTED_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_unremitted_income/`;

export const GET_TRUST_REIT_DISTRIBUTION_API = `${process.env.REACT_APP_API_BASE_URL}/trust_reit_distribution/`;
export const POST_TRUST_REIT_DISTRIBUTION_API = `${process.env.REACT_APP_API_BASE_URL}/trust_reit_distribution/`;
export const COPY_TRUST_REIT_DISTRIBUTION_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/trust_reit_distribution/copy_from_previous_year/`;

export const GET_INTEREST_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/interest_income/`;
export const POST_INTEREST_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/interest_income/`;
export const COPY_INTEREST_INCOME_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/interest_income/copy_from_previous_year/`;

export const GET_OTHER_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/other_income`;
export const POST_OTHER_INCOME_API = `${process.env.REACT_APP_API_BASE_URL}/other_income/`;
export const COPY_OTHER_INCOME_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/other_income/copy_from_previous_year/`;

export const POST_FIXED_ASSETS_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/fixed_assets/`;
export const GET_FIXED_ASSETS_LIST_API = `${process.env.REACT_APP_API_BASE_URL}/fixed_assets/`;

export const POST_INVESTMENT_HOLDING_FIXED_ASSETS_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_fixed_assets/`;
export const GET_INVESTMENT_HOLDING_FIXED_ASSETS_LIST_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_fixed_assets/`;

export const POST_DONATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/donations/`;
export const GET_DONATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/donations/`;

export const POST_INVESTMENT_HOLDING_DONATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_donations/`;
export const GET_INVESTMENT_HOLDING_DONATIONS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_donations/`;

export const POST_INVESTMENT_HOLDING_MEDICAL_EXPENSES_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_medical_expenses/`;
export const GET_INVESTMENT_HOLDING_MEDICAL_EXPENSES_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_medical_expenses/`;
export const COPY_INVESTMENT_HOLDING_MEDICAL_EXPENSES_FROM_PREVIOUS_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_medical_expenses/copy_from_previous_year/`;

export const POST_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_adjustment/`;
export const GET_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_adjustment/`;
export const COPY_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_FROM_PREVIOUS_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_interest_adjustment/copy_from_previous_year/`;

export const POST_TAX_COMPUTATION_ADJUSTMENTS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_adjustments/`;
export const GET_TAX_COMPUTATION_ADJUSTMENTS_API = `${process.env.REACT_APP_API_BASE_URL}/tax_computation_adjustments/`;

export const POST_INCOME_TAX_COMPUTATION_API = `${process.env.REACT_APP_API_BASE_URL}/income_tax_computation/`;
export const GET_INCOME_TAX_COMPUTATION_API = `${process.env.REACT_APP_API_BASE_URL}/income_tax_computation/`;

export const POST_INVESTMENT_HOLDING_INCOME_TAX_COMPUTATION_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_income_tax_computation/`;
export const GET_INVESTMENT_HOLDING_INCOME_TAX_COMPUTATION_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_income_tax_computation/`;

export const POST_COMPUTATION_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/computation_summary/`;
export const GET_COMPUTATION_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/computation_summary/`;

export const POST_INTELLECTUAL_PROPERTY_RIGHTS_API = `${process.env.REACT_APP_API_BASE_URL}/intellectual_property_rights/`;
export const GET_INTELLECTUAL_PROPERTY_RIGHTS_API = `${process.env.REACT_APP_API_BASE_URL}/intellectual_property_rights/`;

export const POST_FURTHER_OTHER_DEDUCTIONS_API = `${process.env.REACT_APP_API_BASE_URL}/further_other_deductions/`;
export const GET_FURTHER_OTHER_DEDUCTIONS_API = `${process.env.REACT_APP_API_BASE_URL}/further_other_deductions/`;
export const COPY_FURTHER_OTHER_DEDUCTIONS_FROM_PREVIOUS_YEAR_API = `${process.env.REACT_APP_API_BASE_URL}/further_other_deductions/copy_from_previous_year/`;

export const POST_INTELLECTUAL_PROPERTY_API = `${process.env.REACT_APP_API_BASE_URL}/intellectual_property/`;
export const GET_INTELLECTUAL_PROPERTY_API = `${process.env.REACT_APP_API_BASE_URL}/intellectual_property/`;

export const POST_TRAINING_EXPENDITURE_API = `${process.env.REACT_APP_API_BASE_URL}/training_expenditure/`;
export const GET_TRAINING_EXPENDITURE_API = `${process.env.REACT_APP_API_BASE_URL}/training_expenditure/`;

export const GET_UNUTILISED_ITEMS_BROUGHT_FORWARD_CARRIED_FORWARD_API = `${process.env.REACT_APP_API_BASE_URL}/unutilised_items_brought_forward_carry_forward/`;
export const POST_UNUTILISED_ITEMS_BROUGHT_FORWARD_CARRIED_FORWARD_API = `${process.env.REACT_APP_API_BASE_URL}/unutilised_items_brought_forward_carry_forward/`;
export const INVESTMENT_HOLDING_UNUTILISED_ITEMS_BROUGHT_FORWARD_CARRIED_FORWARD_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_unutilised_items_brought_forward_carry_forward/`;

export const GET_DISPOSAL_FIXED_ASSETS_API = `${process.env.REACT_APP_API_BASE_URL}/disposal_of_fixed_assets/`;

export const GET_INVESTMENT_HOLDING_DISPOSAL_FIXED_ASSETS_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_disposal_of_fixed_assets/`;

export const GET_CATEGORIES_LIST_API = `${process.env.REACT_APP_API_BASE_URL}/categories/`;
export const GET_WORKING_LIFE_YEARS_API = `${process.env.REACT_APP_API_BASE_URL}/working_life_years/`;

export const GET_CURRENCY_API = `${process.env.REACT_APP_API_BASE_URL}/currency/`;

export const GET_GROUP_RELIEF_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/group_relief/`;
export const POST_GROUP_RELIEF_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/group_relief/`;

export const GET_CARRY_BACK_RELIEF_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/carry_back_relief/`;
export const POST_CARRY_BACK_RELIEF_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/carry_back_relief/`;

export const GET_FRS_116_ADJUSTMENT_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/frs_116_adjustments/`;
export const POST_FRS_116_ADJUSTMENT_DETAILS_API = `${process.env.REACT_APP_API_BASE_URL}/frs_116_adjustments/`;

export const GET_RENOVATION_AND_REFURBISHMENT_WORKS_API = `${process.env.REACT_APP_API_BASE_URL}/renovation_and_refurbishment_works/`;
export const POST_RENOVATION_AND_REFURBISHMENT_WORKS_API = `${process.env.REACT_APP_API_BASE_URL}/renovation_and_refurbishment_works/`;

export const SEND_MAIL_API = `${process.env.REACT_APP_API_BASE_URL}/users/send_credentials/`;
export const SEND_CUSTOMER_DETAILS_MAIL_API = `${process.env.REACT_APP_API_BASE_URL}/customer/send_customer_details/`;

export const GET_SHAREHOLDING_TEST_CAPITAL_ALLOWANCES_API = `${process.env.REACT_APP_API_BASE_URL}/shareholding_test_capital_allowances/`;
export const GET_SHAREHOLDING_TEST_UNABSORBED_LOSSES_API = `${process.env.REACT_APP_API_BASE_URL}/shareholding_test_unabsorbed_losses/`;

export const GET_FTC_POOLING_API = `${process.env.REACT_APP_API_BASE_URL}/foreign_tax_credit_computation/`;

export const GET_INVESTMENT_HOLDING_FTC_POOLING_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_foreign_tax_credit_computation/`;

export const GET_INNOVATION_PROJECT_WITH_PARTNER_INSTITUTION_API = `${process.env.REACT_APP_API_BASE_URL}/partner_institution_innovation_projects/`;

export const GET_RESEARCH_AND_DEVELOPMENT_ACTIVITIES_API = `${process.env.REACT_APP_API_BASE_URL}/rd_activities/`;

export const FORM_CS_API = `${process.env.REACT_APP_API_BASE_URL}/form_cs/`;

export const FORM_C_API = `${process.env.REACT_APP_API_BASE_URL}/form_c/`;

export const INVESTMENT_HOLDING_FORM_C_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_form_c/`;

export const FORM_CS_LITE_API = `${process.env.REACT_APP_API_BASE_URL}/form_cs_lite/`;

export const DASHBOARD_STAGE_API = `${process.env.REACT_APP_API_BASE_URL}/dashboard/stages/`;

export const FIXED_ASSETS_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/fixed_assets_summary/`;

export const INVESTMENT_HOLDING_FIXED_ASSETS_SUMMARY_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_fixed_assets_summary/`;

export const GET_INVESTMENT_HOLDING_SHAREHOLDING_TEST_CAPITAL_ALLOWANCES_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_shareholding_test_capital_allowances/`;
export const GET_INVESTMENT_HOLDING_SHAREHOLDING_TEST_UNABSORBED_LOSSES_API = `${process.env.REACT_APP_API_BASE_URL}/investment_holding_shareholding_test_unabsorbed_losses/`;

export const BASE_IRAS_API = `${process.env.REACT_APP_API_BASE_URL}/iras_tax/`;

export const GET_CHANGE_FORM_TYPE_API = `${process.env.REACT_APP_API_BASE_URL}/change_form_type/`;
export const POST_CHANGE_FORM_TYPE_API = `${process.env.REACT_APP_API_BASE_URL}/change_form_type/`;

export const GET_CHANGE_FYE_API = `${process.env.REACT_APP_API_BASE_URL}/change_fye/`;
export const POST_CHANGE_FYE_API = `${process.env.REACT_APP_API_BASE_URL}/change_fye/`;

export const EMAIL_TEMPLATE_CATEGORY_API = `${process.env.REACT_APP_API_BASE_URL}/email_categories/`;

//Group Reports

export const GET_ECI_DUE_DATE_GROUP_REPORT_API = `${process.env.REACT_APP_API_BASE_URL}/group-report/`;
export const GET_AVAILABLE_SPC_FOR_GROUP_REPORT_API = `${process.env.REACT_APP_API_BASE_URL}/group-report/available-spc/`;

export const CHANGE_REQUESTS_API = `${process.env.REACT_APP_API_BASE_URL}/change_requests/`;
export const CHANGE_REQUEST_MOVE_STAGE_API = `${process.env.REACT_APP_API_BASE_URL}/change_requests/`;
export const CHANGE_REQUEST_WORKFLOW_API = `${process.env.REACT_APP_API_BASE_URL}/change-request-workflow/`;

export const AUDIT_LOGS_API = `${process.env.REACT_APP_API_BASE_URL}/audit-logs/`;
export const AUDIT_LOGS_STATS_API = `${process.env.REACT_APP_API_BASE_URL}/audit-logs/stats/`;
export const AUDIT_LOGS_FILTER_OPTIONS_API = `${process.env.REACT_APP_API_BASE_URL}/audit-logs/filter-options/`;

export const GET_NOA_TRACKING_API = `${process.env.REACT_APP_API_BASE_URL}/noa_tracking/`;
export const POST_NOA_TRACKING_API = `${process.env.REACT_APP_API_BASE_URL}/noa_tracking/`;
export const GET_NOA_COMPUTED_VALUES_API = `${process.env.REACT_APP_API_BASE_URL}/noa_tracking/computed_values/`;
